// @flow
import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import { message as antdMessage } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Path from 'routes/path'
import { setUIState, containerIds } from 'redux/modules/ui'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'

import MainTemplate from 'components/templates/MainTemplate'
import ReservationChangeHostPage from 'components/pages/ReservationChangeHostPage'
import ReservationChangeHostForm from 'components/organisms/ReservationChangeHostForm'
import { getReservationChangeHostFormProps } from 'components/organisms/ReservationChangeHostForm/presenter'
import ReservationSidebarContainer from 'containers/organisms/ReservationSidebar'

import graphql from './graphql'
import { accountLoginUrl } from 'frontend_core/dist/helpers/url'
import PaidyCharge from 'containers/organisms/PaidyCharge'

export type PropTypes = {
  match: {
    params: {
      ownerName: string,
    },
  },
  location: {
    pathname: string,
  },
  history: {
    replace: Function,
    push: Function,
  },
  ui: {
    loading?: ?boolean,
    confirmActionType?: ?'approve' | 'reject',
    isPaidyChargeActive?: ?boolean,
  },
  actions: {
    setUIState: Function,
    fetchReservationDetail: Function,
    approveChangeReservation: Function,
    rejectChangeReservation: Function,
  },
  reservationDetail: ReservationDetailState,
}

class ReservationChangeHostPageContainer extends Component<PropTypes, *, *> {
  static async getInitialProps({ req, res, params, config, isLogin }) {
    if (!isLogin)
      return { redirect: { to: accountLoginUrl(config), status: 302 } }
    return
  }

  constructor(props: PropTypes) {
    super(props)
    this.onClickBackToMessage = this.onClickBackToMessage.bind(this)
    this.onClickApproveConfirm = this.onClickApproveConfirm.bind(this)
    this.onClickDenialConfirm = this.onClickDenialConfirm.bind(this)
    this.onClickApprove = this.onClickApprove.bind(this)
    this.onClickDenial = this.onClickDenial.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.onPaidyChargeSuccess = this.onPaidyChargeSuccess.bind(this)
    this.onPaidyChargeFailed = this.onPaidyChargeFailed.bind(this)
    this.onPaidyChargeClose = this.onPaidyChargeClose.bind(this)
  }

  componentDidMount() {
    const { actions, reservationDetail, match, config, data } = this.props
    const { detail, messages } = reservationDetail

    window.scrollTo(0, 0)

    // 直リンの場合の初期データ取得
    if (!detail.id) {
      actions.fetchReservationDetail({
        userId: data.viewer.id,
        reservationId: match.params.reservationId,
      })
    }
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      backedFromChangeRequest: true,
      isPaidyChargeActive: false,
    })

    // モーダル閉じる
    this.closeModal()
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { actions, data, reservationDetail, history, match } = this.props
    const { reservationDetail: prevReservationDetail } = prevProps

    // エラー系の表示
    if (
      reservationDetail.failedApproveChange !== null &&
      prevReservationDetail.failedApproveChange === null
    ) {
      antdMessage.warning(reservationDetail.failedApproveChange)
    }
  }

  onClickBackToMessage: Function
  onClickBackToMessage(e: Event) {
    const { history, location, match } = this.props
    e.preventDefault()
    history.push(location.pathname)
    history.replace(Path.reservationDetail(match.params.reservationId))
  }

  onClickApproveConfirm: Function
  onClickApproveConfirm(e: Event) {
    const { actions } = this.props
    e.preventDefault()
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      confirmActionType: 'approve',
    })
  }

  onClickDenialConfirm: Function
  onClickDenialConfirm(e: Event) {
    const { actions, data, match } = this.props
    e.preventDefault()
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      confirmActionType: 'reject',
    })
  }

  onClickApprove: Function
  onClickApprove() {
    const { actions, data, match, reservationDetail } = this.props
    const { detail } = reservationDetail
    const unapprovedReservation = (detail || {}).unapproved_reservation
    const isNeedAdditionalPaidyChargeForChange = (
      (unapprovedReservation || {}).billing || {}
    ).is_need_additional_paidy_charge_for_change

    if (isNeedAdditionalPaidyChargeForChange) {
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        isPaidyChargeActive: true,
      })
    } else {
      this.closeModal()
      actions.approveChangeReservation({
        userId: data.viewer.id,
        reservationId: match.params.reservationId,
      })
    }
  }

  onClickDenial: Function
  onClickDenial() {
    const { actions, data, match } = this.props
    this.closeModal()
    actions.rejectChangeReservation({
      userId: data.viewer.id,
      reservationId: match.params.reservationId,
    })
  }

  closeModal: Function
  closeModal() {
    const { actions } = this.props
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      confirmActionType: null,
    })
  }

  onPaidyChargeSuccess: Function
  onPaidyChargeSuccess(paidyPaymentId, paidyChargeAmount) {
    const { actions, data, match } = this.props
    // 2重で呼ばれないようにここでフラグを落とす
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isPaidyChargeActive: false,
      confirmActionType: null,
    })
    actions.approveChangeReservation({
      userId: data.viewer.id,
      reservationId: match.params.reservationId,
      paidyPaymentId: paidyPaymentId,
      paidyChargeAmount: paidyChargeAmount,
    })
  }

  onPaidyChargeFailed: Function
  onPaidyChargeFailed() {
    const { actions, data, match } = this.props
    // 2重で呼ばれないようにここでフラグを落とす
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isPaidyChargeActive: false,
      confirmActionType: null,
    })
    // 失敗時にメッセージを飛ばす
    actions.sendMessage({
      userId: data.viewer.id,
      reservationId: match.params.reservationId,
      text: i18n.t('page.dashboard.reservation.error.failedPaidyCharge'),
      isAuto: true,
    })
  }

  onPaidyChargeClose: Function
  onPaidyChargeClose() {
    const { actions } = this.props
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isPaidyChargeActive: false,
      confirmActionType: null,
    })
  }

  render() {
    const {
      location,
      history,
      match,
      reservationDetail,
      ui,
      actions,
      data,
    } = this.props

    // 未承認予約がなければ直リンクした場合はメッセージ画面に戻す
    if (
      reservationDetail.detail.id &&
      !reservationDetail.detail.unapproved_reservation
    ) {
      if (!reservationDetail.successApproveChange) {
        antdMessage.warning(
          i18n.t('page.dashboard.reservation.error.nothingHostChange'),
        )
      }
      return (
        <Redirect to={Path.reservationDetail(match.params.reservationId)} />
      )
    }

    const { detail } = reservationDetail
    const reservedRoom = detail.room || {}
    const unapproved = detail.unapproved_reservation || {}
    let isButtonTwoBlock = false
    let attentionText = ''
    const modalLocalizeBase =
      ui.confirmActionType === 'approve'
        ? 'page.dashboard.reservation.reservationChangeFromHost.approveModal'
        : 'page.dashboard.reservation.reservationChangeFromHost.rejectModal'
    let approveActionText =
      ui.confirmActionType === 'approve'
        ? i18n.t('page.shared.approval')
        : i18n.t('page.shared.denial')
    if (
      unapproved &&
      (unapproved.billing || {}).is_need_additional_paidy_charge_for_change
    ) {
      if (ui.confirmActionType === 'approve') {
        isButtonTwoBlock = true
        approveActionText = i18n.t('page.shared.l_00072')
        attentionText = i18n.t(
          'page.dashboard.reservation.addPaidyPopupAttention',
        )
      }
    }

    return (
      <MainTemplate
        title={i18n.t('server.www.reservationChangeHost.title', {
          id: detail.id || '',
        })}
        isFixedHeader
        hideMustHeader
        hasFooter={false}
        {...this.props}
      >
        <ReservationChangeHostPage
          sidebarComponent={<ReservationSidebarContainer />}
          isShowContentsSp
          closeModal={this.closeModal}
          onClickApprove={this.onClickApprove}
          onClickDenial={this.onClickDenial}
          isModalActive={!!ui.confirmActionType}
          modal={{
            title: i18n.t(`${modalLocalizeBase}.title`),
            desc: i18n.t(`${modalLocalizeBase}.desc`),
            positiveButton: {
              text: approveActionText,
              onClick:
                ui.confirmActionType === 'approve'
                  ? this.onClickApprove
                  : this.onClickDenial,
            },
          }}
          isButtonTwoBlock={isButtonTwoBlock}
          attentionText={attentionText}
          isLoading={ui.isLoading}
        >
          <ReservationChangeHostForm
            {...getReservationChangeHostFormProps(
              reservationDetail,
              this.onClickBackToMessage,
              this.onClickApproveConfirm,
              this.onClickDenialConfirm,
            )}
          />
        </ReservationChangeHostPage>
        {ui &&
          ui.isPaidyChargeActive && (
            <PaidyCharge
              roomId={unapproved.room.id}
              rentType={unapproved.rent_type}
              billing={unapproved.billing}
              onPaidyChargeSuccess={this.onPaidyChargeSuccess}
              onPaidyChargeFailed={this.onPaidyChargeFailed}
              onPaidyChargeClose={this.onPaidyChargeClose}
            />
          )}
      </MainTemplate>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    reservationDetail: state.reservationDetail,
    config: state.config,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setUIState,
    ...ReservationDetailActions,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const WrappedContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(ReservationChangeHostPageContainer)),
)

export default WrappedContainer



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationChangeHostPage/index.jsx